import * as couponService from '@cart-services/core/couponService'
import { useFpCampaignCouponService } from '@cart-services/hooks/useFpCampaignCouponService'
import { type MergedCoupon, type MergedCouponCriterion } from '@cart-services/types'
import { CART_FORM_ERROR_MESSAGE, type CartFormValues } from '@cart-services/zod-schema/cartFormSchema'
import { GiveawaySelect } from '@cart-ui/GiveawaySelect/GiveawaySelect'
import { fieldRefHelper } from '@utils/fieldRefHelper'
import { useMemo } from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { useContextCampaignCart } from '../CartProvider/CampaignCartProvider'

export interface GiveawaySelectControllerProps {
  index: number
  coupon: MergedCoupon
  criterion: MergedCouponCriterion
  onOpenDialog?: (couponCriterionId: number) => void
}

export const GiveawaySelectController = (props: GiveawaySelectControllerProps) => {
  const { index, coupon, criterion, onOpenDialog } = props
  const { control } = useFormContext<CartFormValues>()
  const { campaignId, countryCode, campaignCode } = useContextCampaignCart()
  const { selectedCouponGiveawayMap } = useFpCampaignCouponService(campaignId, countryCode, campaignCode)

  const {
    couponCriterionId,
    title,
    options,
    isRepeatable,
    isGiveAll,
    isStockPartiallyNotEnough,
    accumulatedGiftSelectionCount,
    defaultGiveawayValues,
  } = useMemo(() => couponService.getGiveawaySelectProps(coupon, criterion, selectedCouponGiveawayMap), [coupon, criterion, selectedCouponGiveawayMap])

  return (
    <Controller
      control={control}
      name={`giveaways.${index}`}
      render={({ field: { ref }, fieldState: { error } }) => (
        <GiveawaySelect
          rootRef={fieldRefHelper(ref)}
          title={title}
          options={options}
          accumulatedGiftSelectionCount={accumulatedGiftSelectionCount}
          isRepeatable={isRepeatable}
          isGiveAll={isGiveAll}
          isStockPartiallyNotEnough={isStockPartiallyNotEnough}
          onClick={() => onOpenDialog?.(couponCriterionId)}
          defaultGiveawayValues={defaultGiveawayValues}
          errorHighlight={error && error.message !== CART_FORM_ERROR_MESSAGE.NOT_ENOUGH_GIVEAWAY_SELECTED}
        />
      )}
    />
  )
}
